<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="
            background: url('/static/img/video-banner-new.jpg');
            background-position: top !important;
          "
        ></div>
        <!-- <img src="/static/img/video-main-banner.svg" /> -->
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">{{ $t("videos") }}</div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div>
      <div class="mx-0 row align-items-start main-video-wrapp">
        <!-- Left Area -->
        <div class="col-xl-9 px-8 pr-md-10 pr-lg-0 pt-6">
          <div class="v-main_wrapper">
            <p class="video-discription-main">
              {{ $t("level_1_discription1") }}
            </p>
            <p class="video-discription-main">
              {{ $t("level_1_discription2") }}
            </p>
            <p class="video-discription-main" style="font-weight: 600">
              {{ $t("level_1_discription3") }}
            </p>
          </div>
          <div class="col-xl-12 pl-0 pr-0">
            <div class="cvc_btn p-0"></div>
          </div>

          <div class="col-xl-12 cdds">
            <div
              v-for="category in categoriesWithVideo"
              class="v_result videos-main-wrapper"
            >
              <div class="videos-main-wrap">
                <div class="m-0 p-0" v-if="category.designationMap[$locale]">
                  <div class="video_title_wrap">
                    <div class="video_title_left">
                      <div class="videos-head">
                        <h1>{{ category.designationMap[$locale] }}</h1>
                        <span
                          v-if="category.internalLearning"
                          class="pro_video_tag_head_new"
                        >
                          {{ $t("internal_learning") }}
                        </span>
                      </div>

                      <v-btn
                        :to="'/edit-category-name?categoryId=' + category.id"
                        v-show="$rights.includes('UPDATE_VIDEO_CATEGORY')"
                        class="ed_btn"
                        ><img
                          src="/static/img/eva_edit.svg"
                          class="edit-video-icon test"
                        />
                      </v-btn>
                    </div>
                    <div class="video_title_right">
                      <v-btn
                        @click="
                          $router.push(
                            '/save_video?selectedCategory=' + category.id
                          )
                        "
                        v-show="$rights.includes('UPLOAD_VIDEO')"
                        class="uv_btn"
                        ><img
                          src="/static/img/ri_video.svg"
                          class="edit-video-icon test"
                      /></v-btn>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      v-for="video1 in category.videos"
                      :key="video1.id"
                      class="col-xl-3 videos-wrapper"
                    >
                      <div
                        v-if="
                          video1.internalDocuments != null &&
                          video1.internalDocuments.length > 0
                        "
                      >
                        <div class="video_section">
                          <button
                            class="video_item grd-wrap"
                            @click.stop="
                              showVideo(
                                video1.internalDocuments,
                                video1,
                                category
                              )
                            "
                          >
                            <div class="zoom-image play-btn-zoom video-wrapper">
                              <img
                                class=""
                                :src="`/files/image/${video1.image}`"
                              />
                            </div>
                            <div class="zoom-image-1 play-btn-zoom">
                              <img
                                class="play_image"
                                src="/static/img/ico_play1.svg"
                                style="width: 53px; height: 53px"
                              />
                            </div>
                            <div
                              v-if="video1.internalLearning"
                              class="pro_video_tag"
                            >
                              {{ $t("internal_learning") }}
                            </div>
                          </button>
                          <div class="twrap_new">
                            <h5 class="video_head">
                              {{ video1.designationMap[$locale] }}
                            </h5>
                            <span
                              style="cursor: pointer"
                              @click="
                                $router.push({
                                  path: '/edit_video',
                                  query: {
                                    videoId: video1.id,
                                  },
                                })
                              "
                              v-show="$rights.includes('UPDATE_VIDEO')"
                              outlined
                              depressed
                              tile
                            >
                              <img
                                src="/static/img/eva_edit.svg"
                                class="edit-video-icon"
                              />
                            </span>
                          </div>
                          <h5 class="video-discription">
                            <span
                              v-if="
                                !readMore[video1.id] &&
                                video1.descriptionsMap[$locale] != null
                              "
                              v-html="
                                sanitizeDescription(
                                  video1.descriptionsMap[$locale].slice(0, 50)
                                )
                              "
                            ></span>
                            <span
                              class="description"
                              v-if="
                                readMore[video1.id] &&
                                video1.descriptionsMap[$locale] != null
                              "
                              v-html="
                                sanitizeDescription(
                                  video1.descriptionsMap[$locale]
                                )
                              "
                            ></span>
                            <button
                              class="show-more-text"
                              @click="showMore(video1.id)"
                              v-if="
                                !readMore[video1.id] &&
                                video1.descriptionsMap[$locale] &&
                                sanitizeDescription(
                                  video1.descriptionsMap[$locale].length
                                ) > 50
                              "
                            >
                              {{ $t("Show_more") }}
                            </button>
                            <button
                              class="show-more-text"
                              @click="showLess(video1.id)"
                              v-if="
                                readMore[video1.id] &&
                                video1.descriptionsMap[$locale] &&
                                sanitizeDescription(
                                  video1.descriptionsMap[$locale].length
                                ) > 50
                              "
                            >
                              {{ $t("Show_less") }}
                            </button>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <hr class="border-btn-wrap-1" /> -->
            </div>
            <v-dialog
              v-model="openAddDialog"
              width="unset"
              content-class="vdialognew"
            >
              <button
                class="stop_video_btn"
                @click="openAddDialog = false"
              ></button>
              <video
                @contextmenu.prevent
                preload="auto"
                class="video_popup"
                controls
                autoplay
                v-if="openAddDialog"
              >
                <source
                  :src="`/files/image/internal/video/${videoUrl}`"
                  type="video/mp4"
                />
              </video>
            </v-dialog>
          </div>
        </div>
        <!-- Right Area -->
        <div
          class="col-xl-3 pl-8 pl-md-12 pl-xl-8 row pt-0"
          :class="{ left_sticky: isScrolled }"
        >
          <div
            class="col-xl-12 right-side-block"
            v-show="$rights.includes('CREATE_VIDEO_CATEGORY')"
          >
            <h4 class="text-uppercase">{{ $t("actions") }}</h4>
            <div class="right-side divider"></div>
            <div class="mt-6"></div>
            <v-btn
              :to="`/enter_category_name`"
              v-show="$rights.includes('CREATE_VIDEO_CATEGORY')"
              outlined
              depressed
              tile
              class="create-video-category savebutton"
              >{{ $t("create_category_name") }}</v-btn
            >
          </div>
          <Contact />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from "./custom/pagination.vue";
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    pagination,
    Breadcrumb,
  },

  data() {
    return {
      isScrolled: false, // State to track if class should be added
      category: { designations: {} },
      readMore: {},
      sanitizedHTML: "",
      videoUrl: "",
      openAddDialog: false,
      languageTab: null,
      categories: [],
      selectedText: "",
      selectedCategory: null,
      video: [],
      categoriesWithVideo: [],
      selectedCategoryVideos: [],
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["clean"],
      ],
      isLoad: false,
    };
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll); // Listen to scroll event
    if (
      this.isLoad != true &&
      !window.location.href.includes("?") &&
      !window.location.href.includes("?lang=")
    ) {
      this.isLoad = true;
      window.location.href =
        window.location.href + "?lang=" + this.$locale.toUpperCase();
    }
    //  this.fetchCategoryName();
    this.fetchAllCategoryWithVideo();
    // if (this.$route.query.videoCategoryId) {
    //   this.selectedCategory = parseInt(this.$route.query.videoCategoryId);
    //   if (isNaN(this.selectedCategory)) {
    //     this.selectedCategory = null;
    //   } else {
    //     this.fetchVideosForCategory(this.selectedCategory);
    //     this.fetchCategoryNameByID();
    //   }
    // } else {
    //   this.selectedCategory = null;
    // }
    document.addEventListener("contextmenu", (event) => {
      event.preventDefault();
    });
  },
  computed: {
    // categories1() {
    //   const categories = Array.isArray(this.categories)
    //     ? this.categories.map((category) => ({
    //         value: category.id,
    //          text: category.designationMap[this.$locale],
    //          isInternal: category.internalLearning,
    //       }))
    //     : [];
    //   return [
    //     {
    //       text: this.$t("select_video_category"),
    //       value: null,
    //     },
    //     ...categories,
    //   ];
    // },
  },

  methods: {
    handleScroll() {
      if (window.scrollY > 558) {
        this.isScrolled = true; // Add class when scroll is more than 100px
      } else {
        this.isScrolled = false; // Remove class when scrolled back up
      }
    },
    handleVideoClick() {
      //Clarity custom event to track video click
      if (typeof window.clarity !== "undefined") {
        window.clarity("event", "Free Videos- Get to Know Us - Post Login");
      }
    },
    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
    showVideo(videoUrl, video1, categoryId) {
      let selectedCategory = this.categoriesWithVideo.find(
        (category) => category.id === categoryId.id
      )?.designations[0].description;
      let videoName = video1.designationMap[this.$locale];
      if (typeof window.clarity !== "undefined") {
        window.clarity(
          "event",
          "Free Videos " + selectedCategory + " " + videoName + " Post Login"
        );
      }

      this.openAddDialog = true;
      this.videoUrl = videoUrl;
    },

    // handleChange() {
    //   if (this.selectedCategory != null) {
    //     this.fetchCategoryNameByID();
    //     this.fetchVideosForCategory(this.selectedCategory);

    //   } else {
    //     this.selectedCategoryVideos = [];
    //   }
    // },

    onError(err) {
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
      }
    },

    // fetchVideosForCategory(selectedCategory) {
    //   console.log(selectedCategory);
    //   var _this = this;

    //   if (selectedCategory !== undefined && !isNaN(selectedCategory)) {
    //     this.$axios
    //       .get(`/api/video/${selectedCategory}`, {
    //         params: {
    //           page: _this.page - 1,
    //           size: _this.ElementPerPage,
    //         },
    //       })
    //       .then((response) => {

    //         _this.video = response.data.content;
    //         _this.totalPages = response.data.totalPages;
    //         _this.$forceUpdate();
    //       });
    //   }
    // },
    fetchAllCategoryWithVideo() {
      var _this = this;
      this.$axios.get(`/api/video/all`).then((response) => {
        _this.categoriesWithVideo = response.data;
        console.log(_this.categoriesWithVideo);
        _this.$forceUpdate();
      });
    },

    // fetchCategoryName() {
    //   var _this = this;
    //   this.$axios
    //     .get("/api/video/category")
    //     .then((response) => {
    //       _this.categories = response.data;

    //     })

    //     .catch(this.onError)
    //     .finally(this.onFinally);
    // },
    sanitizeDescription(description) {
      if (!description) return "";

      const parser = new DOMParser();
      const doc = parser.parseFromString(description, "text/html");

      const paragraphs = doc.querySelectorAll("p");
      for (let i = 0; i < paragraphs.length; i++) {
        const p = paragraphs[i];
        while (p.firstChild) {
          p.parentNode.insertBefore(p.firstChild, p);
        }
        this.readMore[i] = false;
        p.parentNode.removeChild(p);
      }
      const sanitizedHTML = doc.body.innerHTML;

      return sanitizedHTML;
    },
    fetchCategoryNameByID() {
      var _this = this;
      if (this.selectedCategory != null && !isNaN(this.selectedCategory)) {
        this.$axios
          .get("/api/video/categoryname/" + this.selectedCategory)
          .then(function (response) {
            _this.category = response.data;
            _this.category.designations = _this.category.designationMap;
          })
          .catch(this.onError);
      }
    },
    isVideoNotEmpty(video) {
      if (Array.isArray(video)) {
        return video.length > 0;
      }
      return video && Object.keys(video).length > 0;
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll); // Clean up event listener
    // Clean up the event listener when the component is destroyed
    document.removeEventListener("contextmenu", (event) => {
      event.preventDefault();
    });
  },
};
</script>
